import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AlertifyService } from './alertify.service';
import { SaleGutsVM, OperationResult, EditGutSale } from '../models/ViewModels';
import { environment } from '../../environments/environment';
import { ErrorService } from '../interceptors/error.service';

@Injectable({
  providedIn: 'root'
})
export class SaleGutsService {

  salesApi = `${environment.apiUrl}/SaleGuts`;

  constructor(private http: HttpClient,
    private errorService: ErrorService,
    private alertify: AlertifyService) { }

  create(sale: SaleGutsVM) {
    return this.http.post(this.salesApi, sale).pipe(
      map((response: OperationResult<SaleGutsVM>) => {
        if (response.Success) {
          this.alertify.success("Registro creado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  update(editedSale: EditGutSale) {
    return this.http.put(this.salesApi, editedSale).pipe(
      map((response: OperationResult<SaleGutsVM>) => {
        if (response.Success) {
          this.alertify.success("Registro editado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  updatePaidAndPayment(sale: SaleGutsVM) {
    const uri = `${this.salesApi}/UpdatePaidAndPayment`;
    return this.http.put(uri, sale).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Registro editado exitosamente.");
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  delete(id: string) {
    const uri = `${this.salesApi}?uuid=${id}`;
    return this.http.delete(uri).pipe(
      map((response: OperationResult<boolean>) => {
        if (response.Success) {
          this.alertify.success("Registro eliminado exitosamente");
          return true;
        } else {
          this.errorService.logerrorMessage(response);
          return false;
        }
      }));
  }

  getAll() {
    return this.http.get(this.salesApi).pipe(
      map((response: OperationResult<SaleGutsVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  getCustomerSales(customerId: string) {
    const uri = `${this.salesApi}/GetCustomerSales?customerId=${customerId}`;
    return this.http.get(uri).pipe(
      map((response: OperationResult<SaleGutsVM[]>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }

  getById(id: string) {
    const uri = `${this.salesApi}/GetByIdentifier?uuid=${id}`;
    return this.http.get(uri).pipe(
      map((response: OperationResult<SaleGutsVM>) => {
        if (response.Success) {
          return response.Data;
        } else {
          this.errorService.logerrorMessage(response);
          return null;
        }
      }));
  }
}
